import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../../firebase";

const getUserInsurances = async (uid) => {
  const products = [];
  try {
    const vehiclesRef = collection(db, `users/${uid}/vehicles`);
    const q = query(
      vehiclesRef,
      where("isInsured", "==", true),
      where("deleted", "==", false)
    );

    const vehiclesSnapshot = await getDocs(q);
    const vehiclesList = vehiclesSnapshot.docs.map((doc) => {
      const data = doc.data();
      const productsName = `${data.brand || ""} ${data.model || ""} ${
        data.year || ""
      }`;
      products.push({
        id: doc.id,
        label: productsName,
        path: doc.ref.path,
        type: data.type,
      });
      return { ...data, id: doc.id };
    });
    const smartphonesRef = collection(db, `users/${uid}/smartphones`);
    const qS = query(
      smartphonesRef,
      where("isInsured", "==", true),
      where("deleted", "==", false)
    );

    const smartphonesSnapshot = await getDocs(qS);
    const smartphonesList = smartphonesSnapshot.docs.map((doc) => {
      const data = doc.data();
      let productsName = `${data.brand || ""} ${data.model || ""}`;
      let type = data.type;
      if (productsName.trim() === "") {
        productsName = "Celular";
        type = "smartphone";
      }

      products.push({
        id: doc.id,
        label: productsName,
        path: doc.ref.path,
        type,
      });
      return { ...data, id: doc.id };
    });

    return products;
  } catch (err) {
    console.log("Error getting Vehicles data", err);
    return null
  }
};

export default getUserInsurances;
